import React, { useState, useEffect } from "react";
import classes from "./LoginPage.module.css";
import { motion } from "framer-motion";
import LinedSection from "../component/LinedSection";
import Footer from "../component/Footer";
import { v4 as uuidv4 } from "uuid";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getSubStatusApi, loginApi } from "../http/http";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../store/slices/userSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { countryCode } from "../utils/constants";
import SmallLoader from "../component/SmallLoader";

const LoginPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [msisdn, setMsisdn] = useState(
    searchParams.get("mn") ? searchParams.get("mn") : "",
  );
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();
  const [extRef, setExtRef] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userDetails } = useSelector((state) => state?.persisted?.userSlice);

  useEffect(() => {
    if (userDetails?.token) {
      navigate("/home");
    }
  }, [userDetails]);

  useEffect(() => {
    if (searchParams.get("ext_ref")) {
      setExtRef(searchParams.get("ext_ref"));
    } else {
      setSearchParams({ ext_ref: uuidv4() });
    }
  }, [searchParams]);
  const handleFormSubmission = async (e) => {
    e.preventDefault();
    if (msisdn?.trim().length === 0) {
      return;
    }

    if (msisdn.length >= 8) {
      setLoginLoading(true);
      await getSubStatusApi({ mobileNumber: parseInt(msisdn) })
        .then((res) => {
          if (res.responseCode === 200) {
            dispatch(setUser(res?.data));
            window.location.href = "/home";
          } else if (res.responseCode === 203) toast.error(t("lowbalance"));
          else if (res.responseCode === 202)
            toast.info(t("inprocess")); //Charging in process;
          else if (res.responseCode === 204)
            toast.error(t("notSub")); //Not subscribed
          else toast.error(t("errorMsg"));
        })
        .catch((err) => {
          console.log(err);
          toast.error(t("errorMsg"));
        })
        .finally(() => setLoginLoading(false));
    } else {
      toast.error(t("invalidNumber"));
    }
  };
  return (
    <main className={classes.main}>
      <div className={classes.glowLayer} />

      <LinedSection />

      <motion.section
        className={classes.container}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className={classes.bgGlowOne} />
        <div className={classes.bgGlowTwo} />

        <div className={classes.topLogoWrap}>
          <img
            src="/images/logo2.png"
            alt="UV Gaming"
            className={classes.logoImg}
          />
        </div>

        <div className={classes.headingWrap}>
          <h1 className={classes.title}>
            {t("34")}
            <span> {t("35")}</span>
          </h1>
          {/* <p className={classes.subtitle}>
            Passez au niveau supérieur avec une nouvelle expérience de jeu
          </p> */}
        </div>

        <form className={classes.card} onSubmit={handleFormSubmission}>
          <div className={classes.tabSwitch}>
            <button
              type="button"
              className={`${classes.tabBtn} ${classes.tabBtnActive}`}
            >
              {t("36")}
            </button>

            <button
              type="button"
              className={`${classes.tabBtn}`}
              onClick={() => navigate("/subscribe")}
            >
              {t("37")}
            </button>
          </div>

          <div className={classes.formBlock}>
            <label className={classes.label}>{t("38")}</label>

            <div className={classes.phoneField}>
              <div className={classes.phoneCode}>+{countryCode}</div>
              <input
                type="tel"
                placeholder={t("39")}
                onChange={(e) => {
                  setMsisdn(
                    e.target.value && e.target.value.trim().length <= 10
                      ? e.target.value.trim()
                      : e.target.value.trim().slice(0, 10),
                  );
                }}
                value={
                  msisdn && msisdn.trim().length > 10
                    ? msisdn.trim().slice(3)
                    : msisdn
                }
                className={classes.phoneInput}
              />
            </div>
          </div>

          <button
            type="submit"
            className={classes.confirmBtn}
            disabled={loginLoading}
          >
            {loginLoading ? (
              <SmallLoader style={{ border: "5px solid #fff" }} />
            ) : (
              t("1")
            )}
          </button>
        </form>

        <Footer />
      </motion.section>
    </main>
  );
};

export default LoginPage;
